/** */
import { useDispatch } from 'react-redux';
import React, { useState, useEffect, useContext } from 'react';
import { Routes, Route } from 'react-router-dom';

import SideNav from './side-nav/side-nav';
import { ModuleLayout } from './modules';
import { addMetadata } from 'store/actions/metadata';
import './member.css';
import { VirtualAccountContext, VirtualAccountProvider } from 'contexts/checkout/virtual';
import { CreateOrganizationProvider } from 'contexts/organization';
import { VirtualAccountCheckout } from './modules/checkout/modal/virtual';
import GmModal from 'app/shared/modal/modal';
import { useAgencyService } from 'hooks/iam/agency';
import { CreateAgency } from './agency/create';
import Spinner from 'app/shared/spinners/spinner-50/spinner-50';
// import { OnboardingTour } from 'app/shared/onboarding/tour';

const MemberArea = () => {
  const dispatch = useDispatch();
  const { fetchAgencies } = useAgencyService();

  const [has_agency, setHasAgency] = useState(false);
  const [is_fetching_agency, setIsFetchingAgency] = useState(true);
  const [open_menu_tray, setOpenMenuTray] = useState(false);

  useEffect(() => {
    setMobileFlag();
    window.addEventListener('resize', () => {
      setMobileFlag();
    });

    setIsFetchingAgency(true);
    fetchAgencies()
      .then(({ agencies: [agency] }) => {
        dispatch(addMetadata({ agency }));
        // An agency whose registration is unfinished resumes the creation flow.
        setHasAgency(!!agency && !!agency.registration_completed);
      })
      .finally(() => {
        setIsFetchingAgency(false);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setMobileFlag = () => {
    if (window.screen.width < 768) {
      dispatch(addMetadata({ is_mobile_view: true }));
    } else dispatch(addMetadata({ is_mobile_view: false }));
  };

  return (
    <VirtualAccountProvider>
      <div className="member-area-wrapper">
        <section className="app-body">
          {is_fetching_agency ? (
            <div
              style={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Spinner />
            </div>
          ) : (
            <Routes>
              <Route
                path="/*"
                element={
                  has_agency ? (
                    <MemberLayout
                      open_menu_tray={open_menu_tray}
                      setOpenMenuTray={setOpenMenuTray}
                    />
                  ) : (
                    <CreateAgency
                      onCreated={(agency) => {
                        dispatch(addMetadata({ agency }));
                        setHasAgency(true);
                      }}
                    />
                  )
                }
              />
            </Routes>
          )}
        </section>
      </div>
    </VirtualAccountProvider>
  );
};

const MemberLayout = ({ open_menu_tray, setOpenMenuTray }) => {
  const { closeModal: closeVirtualAccountModal, show_modal: show_virtual_account_modal } =
    useContext(VirtualAccountContext);

  return (
    <CreateOrganizationProvider>
      <>
        <SideNav open_tray={open_menu_tray} onTrayClose={() => setOpenMenuTray(false)} />
        <Routes>
          <Route path="/*" element={<ModuleLayout setOpenMenuTray={setOpenMenuTray} />} />
        </Routes>
        {/* <OnboardingTour /> */}
      </>
      <GmModal
        title="Complete Your Payment via Bank Transfer"
        show_title
        show_modal={show_virtual_account_modal}
        onClose={closeVirtualAccountModal}
      >
        <VirtualAccountCheckout />
      </GmModal>
    </CreateOrganizationProvider>
  );
};

export default MemberArea;
